export default "__VITE_ASSET__BfwXJ4rq__"